// extracted by mini-css-extract-plugin
export var cardIcon = "_54-4";
export var checkboxCard = "_54-0";
export var checkboxCardSelected = "_54-3";
export var disabled = "_54-1";
export var outerBorder = "_54-2";
export var spacerMedium = "_54-7";
export var spacerSmall = "_54-6";
export var spacerXsmall = "_54-5";